import React from "react";
import "./Footer.css";
import GoogleAdsense from "react-adsense-google";
function Footer() {
  return <div className="footer"></div>;
}
export default Footer;
